(() => {
  if (window.__COUNTDOWN_BAR_LOADED__) return;
  window.__COUNTDOWN_BAR_LOADED__ = true;

  function parseEnd(endStr) {
    // Accepts "YYYY-MM-DD HH:MM:SS" (local) or any valid Date string
    if (!endStr) return null;
    if (endStr.includes('-')) {
      const [datePart, timePartRaw] = endStr.split(' ');
      const timePart = timePartRaw || '23:59:59';
      // Local time; avoids unintended UTC shift
      return new Date(`${datePart}T${timePart}`);
    }
    const d = new Date(endStr);
    return isNaN(d.getTime()) ? null : d;
  }

  function format(distance) {
    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);
    return `${days}d ${hours}hrs ${minutes}mins ${seconds}secs`;
  }

  function initBar(el) {
    if (el.__initialized) return;
    el.__initialized = true;

    const sectionId = el.getAttribute('data-section-id') || '';
    const endStr = el.getAttribute('data-end') || '';
    const closable = el.getAttribute('data-closable') === 'true';
    const timerEl = document.getElementById(`countdownTimer-${sectionId}`);
    if (!timerEl) return;

    // Persist close state
    const storageKey = `countdownBarHidden:${sectionId}`;
    if (localStorage.getItem(storageKey) === '1') {
      el.classList.add('hidden');
      return;
    }
    if (closable) {
      const closeBtn = el.querySelector('[data-countdown-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          el.classList.add('hidden');
          try { localStorage.setItem(storageKey, '1'); } catch (_) {}
        });
      }
    }

    const end = parseEnd(endStr);
    if (!end) {
      timerEl.textContent = 'Invalid date';
      return;
    }

    // First paint
    const update = () => {
      const now = new Date();
      const distance = end - now;
      if (distance <= 0) {
        timerEl.textContent = 'Offer Expired';
        clearInterval(intervalId);
        return;
      }
      timerEl.textContent = format(distance);
    };

    update();
    const intervalId = setInterval(update, 1000);
    // Clean up if DOM node removed (theme editor)
    const observer = new MutationObserver(() => {
      if (!document.body.contains(el)) {
        clearInterval(intervalId);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll('[data-countdown]').forEach(initBar);
  }

  // Defer until after above-the-fold work is done
  function scheduleInit() {
    const run = () => {
      // Give the main thread a breather
      setTimeout(initAll, 0);
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      // Wait for full load to minimize main-thread contention
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }
  }

  scheduleInit();
})();
